// extracted by css-extract-rspack-plugin
export default {"ModalExternalLink":"PreviewQueryModal-module__ModalExternalLink___W0dqq"};